import { RequestConfig } from '@/interface'

const PRIFIX = 'ypgl/zngx/'

const intelligentCheckConfig: RequestConfig = {
  // 获取测算明细
  zngxCsmx: {
    url: `${PRIFIX}csmx`,
    method: 'post'
  },
  // 获取测算结果
  zngxCsjg: {
    url: `${PRIFIX}csjg`,
    method: 'post'
  },
  // 测算记录分页
  zngxPage: {
    url: `${PRIFIX}page`,
    method: 'post'
  },
  // 覆盖测算结果
  zngxSave: {
    url: `${PRIFIX}save`,
    method: 'post'
  },
  // 提交测算明细
  zngxSubmit: {
    url: `${PRIFIX}submit`,
    method: 'post'
  },
  // 计算应缴增值税
  zngxYjzzs: {
    url: `${PRIFIX}yjzzs`,
    method: 'post'
  },
  // 不勾选操作
  zngxBgxcz: {
    url: `${PRIFIX}bgxcz`,
    method: 'post'
  },
  // 税编查询
  zngxSsbmdlcx: {
    url: `${PRIFIX}ssbmdlcx`,
    method: 'get'
  }
}
export default intelligentCheckConfig
